import React, { Component } from "react";
import { GenericEditPanel } from 'com-gyf-webcore-userinterfacecomponents';
import NovedadesHelper from '../../../../../Common/Helpers/NovedadesHelper';

class TipoTarjeta extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { props } = this;
        const { data, tarjeta } = props;
        let tipoTarjetaNodes = [];
        let tarjetas;
        let tipos = JSON.parse(JSON.stringify(data.tipoTarjetas));

        let tipoTarjetaNovedad = NovedadesHelper.SelectComboConNovedadPorCampos(this.props.codigoNovedad,
            tarjeta.TarjetaTipoId,
            data.novedadesTarjetaDatos,
            data.esNovedadEditada,
            tipos,
            [{ Clave: "TarjetaCreditoId", Valor: tarjeta.TarjetaCreditoId }]);

  
        return <div className="col-xs-12">
            <div>
                <label className="label-primary">Tipo de tarjeta</label>
            </div>
            <div>
                <label className="label-secondary">{tipoTarjetaNovedad.selectComboDescripcion}</label>
            </div>
        </div>
    }
}

export default TipoTarjeta;

